import i18n from '../i18n';

const FREQUENCY = [
  {
    value: 'Weekly',
    label: 'Weekly',
    note:
      'Store credit will be issued every Sunday and expire on end of day Saturday',
    exprires: 7,
  },
  {
    value: 'TwiceAMonth',
    label: 'Twice a month',
    note: 'Store credit will be issued on the 1ˢᵗ and 16ᵗʰ of every month.',
    exprires: '15th and Last day of the month',
  },
  {
    value: 'Monthly',
    label: 'Monthly',
    note: 'Store credit will be issued on the 1ˢᵗ of every month',
    exprires: 'Last day of the month',
  },
  {
    value: 'Quarterly',
    label: 'Quarterly',
    note:
      'Store credit will be issued on Jan 1ˢᵗ, April 1ˢᵗ, July 1ˢᵗ and Oct 1ˢᵗ',
    exprires: 'March 30ᵗʰ, June 30ᵗʰ, September 30th and Dec 31ˢᵗ',
  },
  {
    value: 'Annually',
    label: 'Annually',
    note:
      'Store credit will be issued annually from the day the membership was registered',
    exprires: '',
  },
];

const FREQUENCY_NAME = {
  0: 'Weekly',
  1: 'TwiceAMonth',
  2: 'Monthly',
  3: 'Quarterly',
  4: 'Annually',
};

const membershipStatuses = [
  'Active',
  'Canceled',
  'Pending',
  'Deactivated',
  'Expired',
];

const PartnerEnum = {
  BHN: 'BHN',
  Square: 'Square',
  Clover: 'Clover',
  Shopify: 'Shopify',
};

const TARGET_TYPE = {
  Category: 0,
  Item: 1,
  WholePurchase: 2,
};

// eslint-disable-next-line import/prefer-default-export
export {
  FREQUENCY,
  FREQUENCY_NAME,
  membershipStatuses,
  PartnerEnum,
  TARGET_TYPE,
};
export const dashboards = [
  {
    name: i18n.t('giftCards.giftCards'),
    id: 0,
    link: 'gift-card',
    show: true,
  },
  { name: i18n.t('loyalty.loyalty'), id: 1, link: 'loyalty', show: true },
  {
    name: i18n.t('membership.memberships'),
    id: 2,
    link: 'membership',
    show: true,
  },
  {
    name: i18n.t('storeCredit.storeCredits'),
    id: 3,
    link: 'store-credit',
    show: true,
  },
  { name: i18n.t('coupons.coupons'), id: 4, link: 'coupons', show: true },
  { name: i18n.t('tickets.tickets'), id: 5, link: 'ticket', show: true },
  {
    name: i18n.t('membership.waiver.waivers'),
    id: 6,
    link: 'waiver',
    show: true,
  },
];

export const membershipPlansFrequencies = [
  { value: 'DAILY', text: 'DAILY' },
  { value: 'WEEKLY', text: 'WEEKLY' },
  { value: 'EVERY_TWO_WEEKS', text: 'TWO WEEKS' },
  { value: 'THIRTY_DAYS', text: 'THIRTY DAYS' },
  { value: 'SIXTY_DAYS', text: 'SIXTY DAYS' },
  { value: 'NINETY_DAYS', text: 'NINETY DAYS' },
  { value: 'MONTHLY', text: 'MONTHLY' },
  { value: 'EVERY_TWO_MONTHS', text: 'TWO MONTHS' },
  { value: 'QUARTERLY', text: 'QUARTERLY' },
  { value: 'EVERY_FOUR_MONTHS', text: 'FOUR MONTHS' },
  { value: 'EVERY_SIX_MONTHS', text: 'SIX MONTHS' },
  { value: 'ANNUAL', text: 'ANNUAL' },
  { value: 'EVERY_TWO_YEARS', text: 'TWO YEARS' },
  { value: 'EVERY_THREE_YEARS', text: 'THREE YEARS' },
  { value: 'EVERY_FOUR_YEARS', text: 'FOUR YEARS' },
  { value: 'EVERY_FIVE_YEARS', text: 'FIVE YEARS' },
  { value: 'CUSTOM', text: 'CUSTOM' },
];

export const membershipCouponPlanFrequencies = [
  'DAILY',
  'WEEKLY',
  'EVERY_TWO_WEEKS',
  'MONTHLY',
];

export const membershipStoreCreditFrequencies = [
  { text: 'Daily', value: 'DAILY' },
  { text: 'Weekly', value: 'WEEKLY' },
  { text: 'Bi-Weekly', value: 'EVERY_TWO_WEEKS' },
  { text: 'Monthly', value: 'MONTHLY' },
];

export const daysOfWeek = [
  { value: 1, label: i18n.t('monday') },
  { value: 2, label: i18n.t('tuesday') },
  { value: 3, label: i18n.t('wednesday') },
  { value: 4, label: i18n.t('thursday') },
  { value: 5, label: i18n.t('friday') },
  { value: 6, label: i18n.t('saturday') },
  { value: 0, label: i18n.t('sunday') },
];

export const membershipCouponPlanExpirationPeriod = [
  'DAY',
  'WEEK',
  'TWO WEEKS',
  'MONTH',
  'TWO MONTHS',
  'THREE MONTHS',
  'FOUR MONTHS',
  'SIX MONTHS',
];

export const timezones = [
  { value: 'Pacific/Kwajalein', label: '(GMT -12:00) Eniwetok, Kwajalein' },
  { value: 'Pacific/Midway', label: '(GMT -11:00) Midway Island, Samoa' },
  { value: 'Pacific/Honolulu', label: '(GMT -10:00) Hawaii' },
  { value: 'Pacific/Tahiti', label: '(GMT -9:30) Taiohae' },
  { value: 'America/Anchorage', label: '(GMT -9:00) Alaska' },
  {
    value: 'America/Los_Angeles',
    label: '(GMT -8:00) Pacific Time (US & Canada)',
  },
  { value: 'America/Denver', label: '(GMT -7:00) Mountain Time (US & Canada)' },
  {
    value: 'America/Chicago',
    label: '(GMT -6:00) Central Time (US & Canada), Mexico City',
  },
  {
    value: 'America/New_York',
    label: '(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima',
  },
  { value: 'America/Caracas', label: '(GMT -4:30) Caracas' },
  {
    value: 'America/Halifax',
    label: '(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz',
  },
  { value: 'America/St_Johns', label: '(GMT -3:30) Newfoundland' },
  {
    value: 'America/Sao_Paulo',
    label: '(GMT -3:00) Brazil, Buenos Aires, Georgetown',
  },
  { value: 'Atlantic/Azores', label: '(GMT -2:00) Mid-Atlantic' },
  {
    value: 'Atlantic/Cape_Verde',
    label: '(GMT -1:00) Azores, Cape Verde Islands',
  },
  {
    value: 'UTC',
    label: '(GMT) Western Europe Time, London, Lisbon, Casablanca',
  },
  {
    value: 'Europe/Brussels',
    label: '(GMT +1:00) Brussels, Copenhagen, Madrid, Paris',
  },
  {
    value: 'Europe/Kaliningrad',
    label: '(GMT +2:00) Kaliningrad, South Africa',
  },
  {
    value: 'Asia/Baghdad',
    label: '(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg',
  },
  { value: 'Asia/Tehran', label: '(GMT +3:30) Tehran' },
  {
    value: 'Asia/Dubai',
    label: '(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi',
  },
  { value: 'Asia/Kabul', label: '(GMT +4:30) Kabul' },
  {
    value: 'Asia/Yekaterinburg',
    label: '(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent',
  },
  {
    value: 'Asia/Kolkata',
    label: '(GMT +5:30) Bombay, Calcutta, Madras, New Delhi',
  },
  { value: 'Asia/Kathmandu', label: '(GMT +5:45) Kathmandu, Pokhara' },
  { value: 'Asia/Almaty', label: '(GMT +6:00) Almaty, Dhaka, Colombo' },
  { value: 'Asia/Yangon', label: '(GMT +6:30) Yangon, Mandalay' },
  { value: 'Asia/Bangkok', label: '(GMT +7:00) Bangkok, Hanoi, Jakarta' },
  {
    value: 'Asia/Shanghai',
    label: '(GMT +8:00) Beijing, Perth, Singapore, Hong Kong',
  },
  { value: 'Australia/Eucla', label: '(GMT +8:45) Eucla' },
  {
    value: 'Asia/Tokyo',
    label: '(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk',
  },
  { value: 'Australia/Adelaide', label: '(GMT +9:30) Adelaide, Darwin' },
  {
    value: 'Australia/Sydney',
    label: '(GMT +10:00) Sydney, Guam, Vladivostok',
  },
  { value: 'Australia/Lord_Howe', label: '(GMT +10:30) Lord Howe Island' },
  {
    value: 'Asia/Magadan',
    label: '(GMT +11:00) Magadan, Solomon Islands, New Caledonia',
  },
  { value: 'Pacific/Norfolk', label: '(GMT +11:30) Norfolk Island' },
  {
    value: 'Pacific/Auckland',
    label: '(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka',
  },
  { value: 'Pacific/Chatham', label: '(GMT +12:45) Chatham Islands' },
  { value: 'Pacific/Apia', label: '(GMT +13:00) Apia, Nukualofa' },
  { value: 'Pacific/Kiritimati', label: '(GMT +14:00) Line Islands, Tokelau' },
];

export const membershipStoreCreditExpireTypes = [
  { id: '1', name: i18n.t('automaticStoreCredit.1Week') },
  { id: '2', name: i18n.t('automaticStoreCredit.2Weeks') },
  { id: '3', name: i18n.t('automaticStoreCredit.1Month') },
  { id: '5', name: i18n.t('automaticStoreCredit.3Months') },
  { id: '6', name: i18n.t('automaticStoreCredit.6Months') },
  { id: '7', name: i18n.t('automaticStoreCredit.1Year') },
  { id: '0', name: i18n.t('automaticStoreCredit.syncWithMembershipPlan') },
  { id: '4', name: i18n.t('automaticStoreCredit.never') },
];

export const CHART_COLORS = [
  '#FFDAB4',
  '#DCCCEC',
  '#BCD8EC',
  '#F9E1A8',
  '#D6E5BD',
  '#FFCBE1',
  '#E7D9CC',
  '#B9D9D5',
  '#D0D9E2',
  '#F0E2C3',
];

export const COUPON_COLOR_MAP = {
  totalCoupon: '#FFDAB4',
  totalRedeemed: '#DCCCEC',
  totalBalance: '#BCD8EC',
};

export const MONTHS_OF_YEAR = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const EMAIL_TEMPLATE_GROUP = {
  Others: 0,
  GiftCard: 1,
  StoreCredit: 2,
  Membership: 3,
  Loyalty: 4,
  Coupon: 5,
  Ticket: 6,
};

export const dayMap = {
  0: 'SU',
  1: 'MO',
  2: 'TU',
  3: 'WE',
  4: 'TH',
  5: 'FR',
  6: 'SA',
};

export const fullDayLabelMap = {
  SU: i18n.t('sunday'),
  MO: i18n.t('monday'),
  TU: i18n.t('tuesday'),
  WE: i18n.t('wednesday'),
  TH: i18n.t('thursday'),
  FR: i18n.t('friday'),
  SA: i18n.t('saturday'),
};

export const dayOrder = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];

export const isIPad =
  typeof navigator !== 'undefined' &&
  navigator.maxTouchPoints > 1 &&
  window.innerWidth >= 768 &&
  window.innerWidth <= 1366;
